import React from "react";
import { format, parseISO } from "date-fns";
import { CallViewsByUser } from "../../../types/call-views.types";
import { formatNumber } from "../../../utils/formatters";

interface UsersTableProps {
  data: CallViewsByUser[];
}

const formatLastActive = (value: string): string => {
  if (!value) return "—";
  try {
    return format(parseISO(value), "d MMM yyyy");
  } catch {
    return value;
  }
};

export const UsersTable: React.FC<UsersTableProps> = ({ data }) => {
  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-4"
      data-testid="table-by-user"
      role="region"
      aria-label="Przeglądanie naborów wg użytkownika"
    >
      <h3 className="text-sm font-semibold text-neutral-900 mb-1">
        Przeglądanie wg użytkownika
      </h3>
      <p className="text-xs text-neutral-500 mb-3">
        Sortowane wg sumy odsłon (malejąco). Pełne dane dostępne w eksporcie CSV.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs font-medium text-neutral-500 uppercase border-b border-neutral-200">
              <th scope="col" className="py-2 pr-3">Email</th>
              <th scope="col" className="py-2 pr-3">Organizacja</th>
              <th scope="col" className="py-2 pr-3 text-right">Suma</th>
              <th scope="col" className="py-2 pr-3 text-right">Web lista</th>
              <th scope="col" className="py-2 pr-3 text-right">Web detal</th>
              <th scope="col" className="py-2 pr-3 text-right">API lista</th>
              <th scope="col" className="py-2 pr-3 text-right">API detal</th>
              <th scope="col" className="py-2 pr-3 text-right">Email detal</th>
              <th scope="col" className="py-2 pr-3 text-right">Dni aktywne</th>
              <th scope="col" className="py-2 text-right">Ostatnia aktywność</th>
            </tr>
          </thead>
          <tbody>
            {data.map((u, index) => (
              <tr
                key={u.userId}
                className="border-b border-neutral-50 last:border-0"
                data-testid={`by-user-row-${index}`}
              >
                <td
                  className="py-2 pr-3 text-neutral-900 truncate max-w-[220px]"
                  title={u.email}
                >
                  {u.email}
                </td>
                <td
                  className="py-2 pr-3 text-neutral-600 truncate max-w-[180px]"
                  title={u.tenantName}
                >
                  {u.tenantName || "—"}
                </td>
                <td className="py-2 pr-3 text-right font-medium text-neutral-900 tabular-nums">
                  {formatNumber(u.total)}
                </td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.web_list)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.web_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.api_list)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.api_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.email_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(u.activeDays)}</td>
                <td className="py-2 text-right text-neutral-600 whitespace-nowrap">
                  {formatLastActive(u.lastActive)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTable;
